import axiosInstance from '../../../config/axiosInstance';
const  AgreementService = {
    async GetAllAgreementNotifications(redirectCallback,ContractID) {
        try {            
            const response = await axiosInstance.get(`/Agreement/GetAllAgreementNotification?ContractID=${ContractID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAgreementNotifications(ID,redirectCallback) {
        try {
           const response = await axiosInstance.get(`/Agreement/DeleteAgreementNotification?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetAllAgreementLog(ContractID) {
        try {            
            const response = await axiosInstance.get(`/Agreement/GetAllAgreementLog?ContractID=${ContractID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default AgreementService;